import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PostProvider } from './contexts/PostContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import Layout from './components/layout/Layout';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Profile from './pages/Profile';
import PostDetail from './pages/PostDetail';
import CreatePost from './pages/CreatePost';
import SavedPosts from './pages/SavedPosts';
import VerifiedJournalists from './pages/VerifiedJournalists';
import VerificationApplication from './pages/VerificationApplication';
import AdminDashboard from './pages/AdminDashboard';
import TopicPage from './pages/TopicPage';
import About from './pages/About';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <AuthProvider>
            <PostProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/home" element={<Layout />}>
                  <Route index element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  } />
                  <Route path="profile/:username" element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } />
                  <Route path="posts/:postId" element={
                    <ProtectedRoute>
                      <PostDetail />
                    </ProtectedRoute>
                  } />
                  <Route path="create" element={
                    <ProtectedRoute>
                      <CreatePost />
                    </ProtectedRoute>
                  } />
                  <Route path="bookmarks" element={
                    <ProtectedRoute>
                      <SavedPosts />
                    </ProtectedRoute>
                  } />
                  <Route path="verified" element={
                    <ProtectedRoute>
                      <VerifiedJournalists />
                    </ProtectedRoute>
                  } />
                  <Route path="verify" element={
                    <ProtectedRoute>
                      <VerificationApplication />
                    </ProtectedRoute>
                  } />
                  <Route path="admin" element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } />
                  <Route path="topic/:topic" element={
                    <ProtectedRoute>
                      <TopicPage />
                    </ProtectedRoute>
                  } />
                  <Route path="about" element={
                    <ProtectedRoute>
                      <About />
                    </ProtectedRoute>
                  } />
                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </PostProvider>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;